var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "worldcup-detail" },
    [
      _c(
        "button",
        {
          staticClass: "back-btn",
          on: {
            click: function ($event) {
              return _vm.$router.push({ name: "worldcup" })
            },
          },
        },
        [_vm._v("返回赛程")]
      ),
      _vm.loading
        ? _c("div", { staticClass: "state" }, [_vm._v("比赛加载中...")])
        : _vm.match
        ? [
            _c("div", { staticClass: "score-board" }, [
              _c("div", { staticClass: "team" }, [
                _vm.match.homeTeamLogoUrl
                  ? _c("img", {
                      staticClass: "team-logo",
                      attrs: { src: _vm.match.homeTeamLogoUrl, alt: "" },
                      on: { error: _vm.hideBrokenImage },
                    })
                  : _vm._e(),
                _c("span", { staticClass: "team-name" }, [
                  _vm._v(
                    _vm._s(
                      _vm.teamName(
                        _vm.match.competitionCode,
                        _vm.match.homeTeamCode,
                        _vm.match.homeTeam
                      )
                    )
                  ),
                ]),
              ]),
              _c("div", { staticClass: "score" }, [
                _vm.hasScore
                  ? _c("strong", [
                      _vm._v(
                        _vm._s(_vm.match.homeScore) +
                          " : " +
                          _vm._s(_vm.match.awayScore)
                      ),
                    ])
                  : _c("strong", [_vm._v("VS")]),
                _c("em", [
                  _vm._v(
                    _vm._s(_vm.competitionName(_vm.match.competitionCode))
                  ),
                ]),
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.formatDate(_vm.match.startTime)) +
                      " · " +
                      _vm._s(_vm.getStatusName(_vm.match.status))
                  ),
                ]),
              ]),
              _c("div", { staticClass: "team right" }, [
                _c("span", { staticClass: "team-name" }, [
                  _vm._v(
                    _vm._s(
                      _vm.teamName(
                        _vm.match.competitionCode,
                        _vm.match.awayTeamCode,
                        _vm.match.awayTeam
                      )
                    )
                  ),
                ]),
                _vm.match.awayTeamLogoUrl
                  ? _c("img", {
                      staticClass: "team-logo",
                      attrs: { src: _vm.match.awayTeamLogoUrl, alt: "" },
                      on: { error: _vm.hideBrokenImage },
                    })
                  : _vm._e(),
              ]),
            ]),
            _c("div", { staticClass: "tabs" }, [
              _c(
                "button",
                {
                  class: { active: _vm.activeMarket === "WinDrawLose" },
                  on: {
                    click: function ($event) {
                      _vm.activeMarket = "WinDrawLose"
                    },
                  },
                },
                [_vm._v("胜平负")]
              ),
              _c(
                "button",
                {
                  class: { active: _vm.activeMarket === "CorrectScore" },
                  on: {
                    click: function ($event) {
                      _vm.activeMarket = "CorrectScore"
                    },
                  },
                },
                [_vm._v("波胆")]
              ),
            ]),
            _c("div", { staticClass: "bet-area" }, [
              _vm.activeMarket === "CorrectScore"
                ? _c(
                    "div",
                    { staticClass: "score-sections" },
                    _vm._l(_vm.groupedCorrectScoreMarkets, function (group) {
                      return _c(
                        "div",
                        { key: group.key, staticClass: "score-section" },
                        [
                          _c("div", { staticClass: "score-section-title" }, [
                            _vm._v(_vm._s(group.title)),
                          ]),
                          _c(
                            "div",
                            { staticClass: "selection-grid score" },
                            _vm._l(group.items, function (item) {
                              return _c(
                                "button",
                                {
                                  key: item.selectionKey,
                                  class: {
                                    selected:
                                      _vm.selected &&
                                      _vm.selected.selectionKey ===
                                        item.selectionKey,
                                  },
                                  attrs: { disabled: !_vm.canSelect(item) },
                                  on: {
                                    click: function ($event) {
                                      return _vm.selectMarket(item)
                                    },
                                  },
                                },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(item.selectionName)),
                                  ]),
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.formatOdds(item.odds))),
                                  ]),
                                ]
                              )
                            }),
                            0
                          ),
                        ]
                      )
                    }),
                    0
                  )
                : _c(
                    "div",
                    { staticClass: "selection-grid" },
                    _vm._l(_vm.currentMarkets, function (item) {
                      return _c(
                        "button",
                        {
                          key: item.selectionKey,
                          class: {
                            selected:
                              _vm.selected &&
                              _vm.selected.selectionKey === item.selectionKey,
                          },
                          attrs: { disabled: !_vm.canSelect(item) },
                          on: {
                            click: function ($event) {
                              return _vm.selectMarket(item)
                            },
                          },
                        },
                        [
                          _c("span", [_vm._v(_vm._s(item.selectionName))]),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.formatOdds(item.odds))),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
              _c("div", { staticClass: "bet-panel" }, [
                _c("div", { staticClass: "panel-title" }, [_vm._v("下注")]),
                _c("div", { staticClass: "selected-line" }, [
                  _c("span", [_vm._v("当前选择")]),
                  _c("strong", [
                    _vm._v(
                      _vm._s(
                        _vm.selected ? _vm.selected.selectionName : "请选择"
                      )
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "selected-line" }, [
                  _c("span", [_vm._v("赔率")]),
                  _c("strong", [
                    _vm._v(
                      _vm._s(
                        _vm.selected ? _vm.formatOdds(_vm.selected.odds) : "--"
                      )
                    ),
                  ]),
                ]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.number",
                      value: _vm.amount,
                      expression: "amount",
                      modifiers: { number: true },
                    },
                  ],
                  attrs: {
                    type: "number",
                    min: "5",
                    placeholder: "至少下注5欢乐豆",
                  },
                  domProps: { value: _vm.amount },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.amount = _vm._n($event.target.value)
                    },
                    blur: function ($event) {
                      return _vm.$forceUpdate()
                    },
                  },
                }),
                _c("div", { staticClass: "payout" }, [
                  _vm._v("预计派奖：" + _vm._s(_vm.expectedPayout)),
                ]),
                _c(
                  "button",
                  {
                    staticClass: "submit-btn",
                    attrs: { disabled: !_vm.canBetNow },
                    on: { click: _vm.submitBet },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.match.canBet ? "确认下注" : "已停止下注") +
                        " "
                    ),
                  ]
                ),
                _c("p", { staticClass: "hint" }, [
                  _vm._v("赔率按下注时快照结算，淘汰赛按90分钟含伤停比分。"),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "history-layout" }, [
              _c(
                "div",
                { staticClass: "history-panel" },
                [
                  _c("h3", [_vm._v("最近下注")]),
                  _vm.recentBets.length === 0
                    ? _c("div", { staticClass: "empty" }, [
                        _vm._v("暂无下注记录"),
                      ])
                    : _vm._e(),
                  _vm._l(_vm.recentBets, function (bet) {
                    return _c(
                      "div",
                      {
                        key: "recent-" + bet.id,
                        staticClass: "recent-bet-row",
                      },
                      [
                        _c("span", { staticClass: "member-name" }, [
                          _vm._v(_vm._s(bet.memberName || "匿名用户")),
                        ]),
                        _c("strong", [_vm._v(_vm._s(bet.selectionName))]),
                        _c("span", [
                          _vm._v(_vm._s(_vm.statusName(bet.status))),
                        ]),
                      ]
                    )
                  }),
                ],
                2
              ),
              _c(
                "div",
                { staticClass: "history-panel" },
                [
                  _c("h3", [_vm._v("我的下注")]),
                  _vm.myBets.length === 0
                    ? _c("div", { staticClass: "empty" }, [
                        _vm._v("暂无下注记录"),
                      ])
                    : _vm._e(),
                  _vm._l(_vm.myBets, function (bet) {
                    return _c("div", { key: bet.id, staticClass: "bet-row" }, [
                      _c("span", [
                        _vm._v(_vm._s(_vm.marketName(bet.marketType))),
                      ]),
                      _c("strong", [_vm._v(_vm._s(bet.selectionName))]),
                      _c("span", [
                        _vm._v(
                          _vm._s(bet.amount) +
                            "豆 × " +
                            _vm._s(_vm.formatOdds(bet.oddsSnapshot))
                        ),
                      ]),
                      _c("span", [_vm._v(_vm._s(_vm.statusName(bet.status)))]),
                    ])
                  }),
                ],
                2
              ),
            ]),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }